import Vue from 'vue'
import Router from 'vue-router'
import customer from '@/components/customer/customers/customer'
import report from '@/components/customer/report/report1'
import login from '@/components/login'
import talks from '@/components/customer/talks/talk'
import hhrecord from '@/components/customer/hhrecords/hhrecord'
import lyrecord from '@/components/customer/lyrecords/messageRecord'
import custsetting from '@/components/customer/setting/settings'
import baseManage from '@/components/manage/baseManage/baseManage'
import custom from '@/components/manage/custom/custom'
import staff from '@/components/manage/staff/staff'
import system from '@/components/manage/system/system'
import managesetting from '@/components/manage/setting/setting'
import checkLogin from '@/components/customer/checkLogin/checkLogin'
import error500 from '@/components/errorPage/500'
import error403 from '@/components/errorPage/403'
import error404 from '@/components/errorPage/404'
import auditList from '@/components/manage/audit/list'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'HellowWorld',
      redirect: '/check',
      component: login,
      meta: {
        needLogin: true

      }
    }, {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/check',
      name: 'check',
      component: checkLogin
    }, {
      path: '/customs',
      name: 'customs',
      component: customer,
      meta: {
        needLogin: true,
        roles: [2, 3]
      },
      children: [{
          path: 'talks',
          name: 'talks',
          component: talks,
          meta: {
            needLogin: true,
            roles: [2, 3]
          }
        }, {
          path: 'lyrecord',
          name: 'lyrecord',
          component: lyrecord,
          meta: {
            needLogin: true,
            roles: [2, 3]
          }
        }, {
          path: 'report',
          name: 'report',
          component: report,
          meta: {
            needLogin: true,
            roles: [2, 3]
          }
        }, {
          path: 'hhrecord',
          name: 'hhrecord',
          component: hhrecord,
          meta: {
            needLogin: true,
            roles: [2, 3]
          }
        },
        {
          path: 'setting',
          name: 'setting',
          component: custsetting,
          meta: {
            needLogin: true,
            sr:true,
            roles: [2, 3]
          }
        },
        {
          path: 'err403',
          name: 'err403',
          component: error403,
          meta: {
            needLogin: true
          }
        },
        {
          path: 'err404',
          name: '404',
          component: error404,
          meta: {
            needLogin: true
          }
        },
        {
          path: 'err500',
          name: '500',
          component: error500,
          meta: {
            needLogin: true
          }
        }
      ]
    }, {
      path: '/manage',
      name: 'manage',
      component: baseManage,
      meta: {
        needLogin: true
      },
      children: [{
          path: 'staff',
          name: 'staff',
          component: staff,
          meta: {
            needLogin: true,
            roles: [2]
          }
        }, {
          path: 'custom',
          name: 'custom',
          component: custom,
          meta: {
            needLogin: true,
            roles: [2]
          }
        }, //客户
        {
          path: 'system',
          name: 'system',
          component: system,
          meta: {
            needLogin: true,
            roles: [2]
          }
        }, //系统
        {
          path: 'setting',
          name: 'system',
          component: managesetting,
          meta: {
            needLogin: true,
            roles: [2]
          }
        },
        {
          path:'auditList',
          name: 'audit_list',
          component:auditList,
          meta:{
            needLogin:true,
            roles:[2,4]
          }
        },
        {
          path: 'err403',
          name: 'err403',
          component: error403,
          meta: {
            needLogin: true
          }
        },
        {
          path: 'err404',
          name: '404',
          component: error404,
          meta: {
            needLogin: true
          }
        },
        {
          path: 'err500',
          name: '500',
          component: error500,
          meta: {
            needLogin: true
          }
        }
      ]
    },

    {
      path: '*',
      redirect: '/'
    }
  ]
})

// {
//   path: '/manage',
//   name: 'manage',
//   component: manage
// }
// export default new Router({
//   routes: [{
//       path: '/',
//       name: 'HelloWorld',
//       redirect: '/customs',
//       component: HelloWorld,
//       children: [{
//           path: '/staff',
//           redirect: '/staff/manage',
//           component: staff,
//           children: [{
//             path: '/staff/manage',
//             component: manage,
//           }]
//         }, //员工
//         {
//           path: '/custom',
//           component: custom
//         }, //客户
//         {
//           path: '/system',
//           component: system
//         }, //系统
//         {
//           path: '/setting',
//           component: setting
//         } //设置
//       ]
//     },
//     {
//       path: '/customs',
//       name: 'customs',
//       component: customer
//     }, {
//       path: '/login',
//       name: 'login',
//       component: login
//     }

//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js